export default __webpack_public_path__ + "static/media/yaml.1d29fffe.svg";